import React from 'react';
import { connect } from 'react-redux';

import './styles.scss';

const FooterSection = ({ footer }) => (
  <div
    className="seo-footer-section footer_block"
    dangerouslySetInnerHTML={{ __html: footer }}
    suppressHydrationWarning
  />
);

const mapStateToProps = ({ seo }) => ({
  footer: seo?.metaData?.footer_body,
});
export default connect(mapStateToProps, null)(FooterSection);
